import { gql, useMutation } from '@apollo/client';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import UICopyButton from 'UIComponents/button/UICopyButton';
import UILink from 'UIComponents/link/UILink';
import { addAlert } from '../../utils/alerts';
import { URLS } from '../../utils/constants';
import { useTracker } from '../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
export const SUBMIT_UPDATE_PAYMENT_METHOD_EMAIL_MUTATION = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"mutation\",\"name\":{\"kind\":\"Name\",\"value\":\"SubmitUpdatePaymentMethodEmailMutation\"},\"variableDefinitions\":[{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectId\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Long\"}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"toEmailAddress\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"alias\":{\"kind\":\"Name\",\"value\":\"response\"},\"name\":{\"kind\":\"Name\",\"value\":\"sendPaymentMethodUpdateEmail\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"input\"},\"value\":{\"kind\":\"ObjectValue\",\"fields\":[{\"kind\":\"ObjectField\",\"name\":{\"kind\":\"Name\",\"value\":\"objectId\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectId\"}}},{\"kind\":\"ObjectField\",\"name\":{\"kind\":\"Name\",\"value\":\"toEmailAddress\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"toEmailAddress\"}}}]}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"objectId\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"userErrors\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"paymentMethodUpdateUrl\"}}]}}]}}]}", {
  id: null,
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "SubmitUpdatePaymentMethodEmailMutation"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "objectId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "Long"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "toEmailAddress"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        alias: {
          kind: "Name",
          value: "response"
        },
        name: {
          kind: "Name",
          value: "sendPaymentMethodUpdateEmail"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "ObjectValue",
            fields: [{
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "objectId"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "objectId"
                }
              }
            }, {
              kind: "ObjectField",
              name: {
                kind: "Name",
                value: "toEmailAddress"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "toEmailAddress"
                }
              }
            }]
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "objectId"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "userErrors"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "paymentMethodUpdateUrl"
            }
          }]
        }
      }]
    }
  }]
});
export function useUpdatePaymentMethodMutation(objectId, customerEmail, onClose) {
  const {
    trackUsage
  } = useTracker();
  const handleError = useCallback((error, paymentMethodUpdateUrl) => {
    if (error === 'PREVIOUSLY_BOUNCED') {
      addAlert({
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.UpdatePaymentMethodModal.errorSending.previouslyBounced.title"
        }),
        message: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "subscriptions.UpdatePaymentMethodModal.errorSending.previouslyBounced.message_jsx",
          options: {
            linkProps: {
              href: URLS.KBUpdateBouncedEmail,
              external: false
            },
            buttonProps: {
              value: paymentMethodUpdateUrl,
              size: 'xs',
              use: 'tertiary',
              className: 'display-block m-top-2'
            }
          },
          elements: {
            Link: UILink,
            Button: UICopyButton
          }
        }),
        type: 'danger'
      });
    } else {
      addAlert({
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.UpdatePaymentMethodModal.errorSending.default.title"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.UpdatePaymentMethodModal.errorSending.default.message"
        }),
        type: 'danger'
      });
    }
    onClose();
  }, [onClose]);
  return useMutation(SUBMIT_UPDATE_PAYMENT_METHOD_EMAIL_MUTATION, {
    variables: {
      objectId,
      toEmailAddress: customerEmail
    },
    onCompleted: ({
      response: {
        userErrors,
        paymentMethodUpdateUrl
      }
    }) => {
      if (userErrors.length) {
        return handleError(userErrors[0], paymentMethodUpdateUrl);
      }
      addAlert({
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.UpdatePaymentMethodModal.successfullySentTitle"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.UpdatePaymentMethodModal.successfullySentMessage"
        }),
        type: 'success'
      });
      trackUsage('updateSubscriptionPaymentMethodModalSubmitted');
      onClose();
    }
  });
}